import React, { forwardRef } from "react";
import IBuildrProps from "../../utilities/IBuildrProps";
import { useCardDeckContext } from "../../context/CardDeckContext";
import SimpleText from "./SimpleText";
import SimpleTextPhoto from "./SimpleTextPhoto";
import SolidColor from "./SolidColor";
import SolidColorPhoto from "./SolidColorPhoto";
import CardTypeEnum from "./CardTypeEnum";

export interface ICardProps extends IBuildrProps {
    cardTitle: string;
    cardBody?: string;
    cardFooter?: string;
    cardImage: string;
    cardAlt: string;
    className?: string;
    cardIndex?: number;
    isCardSmall?: boolean;
    backgroundColor?: string;
    href?: string;
    dataTestId?: string;
    children?;
}

const Card = forwardRef((props: ICardProps, ref: any) => {
    const { cardType } = useCardDeckContext();
    switch(cardType) {
        case CardTypeEnum.SimpleText:
            return <SimpleText {...props} />;
        case CardTypeEnum.SimpleTextPhoto:
            return <SimpleTextPhoto {...props} />;
        case CardTypeEnum.SolidColor:
            return <SolidColor {...props} />;
        case CardTypeEnum.SolidColorPhoto:
            return <SolidColorPhoto {...props} />;
        default:
            return <div ref={ref} style={{color: 'red'}} className="p-1">Invalid Card type: "{cardType}"</div>;
    };
});

export default Card;